import LegalLayout, { type LegalSection } from "./components/LegalLayout";

const sections: LegalSection[] = [
  {
    id: "acceptance",
    heading: "Acceptance of These Terms",
    paragraphs: [
      "By accessing or using the Voxmaster LLC (\"Voxmaster,\" \"we,\" \"us\") website and services, you agree to be bound by these Terms of Service. If you are entering into these terms on behalf of a company or other legal entity, you represent that you have authority to bind that entity. If you do not agree, you may not use our services.",
    ],
  },
  {
    id: "description-of-services",
    heading: "Description of Services",
    paragraphs: [
      "Voxmaster provides wholesale voice termination, DID origination, SIP trunking, and related telecommunications services to operators, resellers, call centers, and CPaaS platforms. Specific service terms, service level commitments, and pricing are set out in the applicable service order or Master Service Agreement between you and Voxmaster.",
    ],
  },
  {
    id: "account-responsibilities",
    heading: "Account and Security",
    paragraphs: [
      "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. You must promptly notify us of any unauthorized use or security breach. You agree to provide accurate, current, and complete information when creating and maintaining your account.",
    ],
  },
  {
    id: "acceptable-use",
    heading: "Acceptable Use",
    paragraphs: [
      "You agree not to use the services to:",
    ],
    items: [
      "Transmit unlawful, fraudulent, deceptive, or illegal traffic, including robocalls or traffic that violates applicable laws.",
      "Engage in, facilitate, or originate spam, phishing, or any form of abusive or nuisance calling.",
      "Interfere with or disrupt the integrity, security, or performance of the network or any third-party systems.",
      "Attempt to gain unauthorized access to any portion of the service or related systems.",
      "Resell or redistribute services in a manner inconsistent with your agreement with Voxmaster.",
    ],
  },
  {
    id: "fraud-prevention",
    heading: "Fraud Prevention and Compliance",
    paragraphs: [
      "Voxmaster operates fraud detection and traffic monitoring systems designed to protect the integrity of the network. We may suspend or restrict service where we reasonably believe traffic violates applicable law, these terms, or our compliance policies. You are responsible for the legality of the traffic you originate and route through our network.",
    ],
  },
  {
    id: "billing-payment",
    heading: "Billing and Payment",
    paragraphs: [
      "Fees for services are set out in the applicable service order or agreement. Unless otherwise agreed, invoices are due upon receipt. Late payments may result in suspension of service. You are responsible for all charges incurred on your account, including any usage-based charges, regardless of whether authorized by you, except where caused by our willful misconduct.",
    ],
  },
  {
    id: "intellectual-property",
    heading: "Intellectual Property",
    paragraphs: [
      "The Voxmaster platform, website, software, documentation, and all related materials are owned by Voxmaster or its licensors and are protected by intellectual property laws. We grant you a limited, non-exclusive, non-transferable, revocable right to use the services solely for your internal business purposes in accordance with these terms.",
    ],
  },
  {
    id: "disclaimer",
    heading: "Disclaimer of Warranties",
    paragraphs: [
      "The services are provided on an \"as is\" and \"as available\" basis, without warranties of any kind, whether express or implied, including warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the services will be uninterrupted, error-free, or completely secure.",
    ],
  },
  {
    id: "limitation-of-liability",
    heading: "Limitation of Liability",
    paragraphs: [
      "To the maximum extent permitted by law, Voxmaster shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits, revenue, data, or business, arising out of or related to your use of the services. Our aggregate liability under these terms shall not exceed the amounts paid by you for the services in the twelve months preceding the event giving rise to the claim.",
    ],
  },
  {
    id: "indemnification",
    heading: "Indemnification",
    paragraphs: [
      "You agree to indemnify, defend, and hold harmless Voxmaster and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of your use of the services, your violation of these terms, or your violation of applicable law or third-party rights.",
    ],
  },
  {
    id: "termination",
    heading: "Termination",
    paragraphs: [
      "Either party may terminate your use of the services in accordance with the applicable agreement. Upon termination, your right to access and use the services will immediately cease, and any accrued but unpaid obligations will remain due. Provisions that by their nature should survive termination will continue in effect.",
    ],
  },
  {
    id: "governing-law",
    heading: "Governing Law and Contact",
    paragraphs: [
      "These terms are governed by the laws of the State of Nevada, United States, without regard to conflict of law principles, and any disputes will be resolved in the courts located in Clark County, Nevada. Questions about these terms may be directed to legal@voxmaster.com.",
    ],
  },
];

export default function TermsOfService() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="August 15, 2026"
      intro="These Terms of Service govern your access to and use of the Voxmaster website and platform, and apply alongside any service order or Master Service Agreement you have entered into with Voxmaster LLC."
      sections={sections}
      active="terms"
    />
  );
}